import { render, staticRenderFns } from "./TokensSettings.vue?vue&type=template&id=393fd69a&"
import script from "./TokensSettings.vue?vue&type=script&lang=js&"
export * from "./TokensSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports